export default theme => ({
  root: {
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxSizing: "border-box",
    height: 76,
    padding: "16px 20px",
    backgroundColor: "#fcfcfc",
    zIndex: 100,
  },

  logo: {
    display: "block",
    width: 103,
    height: 34,
    objectFit: "contain",
    flexShrink: 0,
  },

  eccoLogo: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
  },

  actions: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexShrink: 0,
  },

  iconBtn: {
    width: 40,
    height: 40,
    padding: 8,
    boxSizing: "border-box",
    borderRadius: 24,
    border: "1px solid #a8a8a8",
    backgroundColor: "#fcfcfc",
    color: "#6b6b6b",
    "&:hover": {
      backgroundColor: "#fcfcfc",
    },
    "& img": {
      display: "block",
      width: 24,
      height: 24,
    },
    "& .MuiSvgIcon-root": {
      fontSize: 24,
    },
  },

  /* Drawer paper — Figma menu-items-mobile */
  drawerPaper: {
    width: 336,
    maxWidth: "100vw",
    backgroundColor: "#fcfcfc",
    borderRadius: "8px 0 0 8px",
    border: "1px solid #e3e3e3",
    borderRight: 0,
    boxShadow: "0px 4px 16px rgba(0,0,0,0.05)",
    overflow: "hidden",
  },

  drawerBackdrop: {
    backgroundColor: "rgba(0,0,0,0.6)",
  },

  panel: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    boxSizing: "border-box",
    paddingBottom: 16,
  },

  panelBody: {
    flex: "1 1 auto",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "16px 16px 8px",
    overflowY: "auto",
    minHeight: 0,
  },

  closeRow: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },

  closeBtn: {
    width: 32,
    height: 32,
    padding: 0,
    boxSizing: "border-box",
    borderRadius: 24,
    border: "1px solid #e3e3e3",
    backgroundColor: "#fcfcfc",
    "&:hover": {
      backgroundColor: "#fcfcfc",
    },
    "& img": {
      display: "block",
      width: 16,
      height: 16,
    },
  },

  navList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },

  section: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },

  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    width: "100%",
    boxSizing: "border-box",
    padding: 8,
    margin: 0,
    border: 0,
    borderRadius: 4,
    background: "none",
    cursor: "pointer",
    textAlign: "left",
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  sectionHeaderLink: {
    textDecoration: "none",
    color: "inherit",
    display: "flex",
  },

  bullet: {
    width: 32,
    height: 32,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      display: "block",
      width: 16,
      height: 16,
    },
  },

  sectionLabelWrap: {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid transparent",
    boxSizing: "border-box",
  },

  sectionLabelWrapActive: {
    borderBottomColor: "#e17300",
  },

  sectionLabel: {
    flex: "1 1 auto",
    minWidth: 0,
    margin: 0,
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.25,
    color: "#6b6b6b",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  sectionLabelActive: {
    color: "#333232",
  },

  chevron: {
    display: "block",
    width: 20,
    height: 20,
    flexShrink: 0,
    transition: "transform 0.2s ease",
  },

  chevronOpen: {
    transform: "scaleY(-1)",
  },

  submenu: {
    display: "flex",
    alignItems: "stretch",
    width: "100%",
  },

  submenuRail: {
    width: 24,
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    padding: "0 10px",
    boxSizing: "border-box",
  },

  submenuRailLine: {
    width: 1,
    alignSelf: "stretch",
    backgroundColor: "#e3e3e3",
  },

  submenuItems: {
    flex: "1 1 auto",
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  subLink: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    padding: 8,
    margin: 0,
    textDecoration: "none",
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    color: "#6b6b6b",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  subLinkHeading: {
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.2,
    color: "#333232",
  },

  ctaWrap: {
    flexShrink: 0,
    display: "flex",
    justifyContent: "center",
    padding: "0 8px",
  },

  cta: {
    "&&": {
      width: "100%",
      maxWidth: 320,
      minHeight: 48,
      height: 48,
      borderRadius: 10,
      padding: "12px 16px",
      fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.5,
      textTransform: "none",
      boxShadow: "none",
    },
  },
});
